import { cssVar } from '@chakra-ui/react';

const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');

const baseStyleTrack = () => {
  return {
    borderRadius: 'full',
    p: '2px',
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: 'common',
    transitionDuration: 'fast',
    bg: 'secondary-300',
    _focus: {
      boxShadow: 'none',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    _checked: {
      bg: '#00875A',
    },
  };
};

const baseStyle = (props) => ({
  track: baseStyleTrack(props),
});

const sizes = {
  md: {
    container: {
      [$width.variable]: '30px',
      [$height.variable]: '14px',
    },
  },
};

const defaultProps = {
  size: 'md',
};

export const Switch = {
  baseStyle,
  sizes,
  defaultProps,
};
